import React from 'react';

import { Control, FieldValues, Path } from 'react-hook-form';

import { MenuItem } from '@mui/material';

import { Select } from '../Common/Forms/fields';

import { CharterFilteringOptions } from './types';

type CharterTypeFiltersDropdownProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  disabled?: boolean;
};

export default function CharterTypeFiltersDropdown<T extends FieldValues>({
  control,
  name,
  disabled = false,
}: CharterTypeFiltersDropdownProps<T>) {
  return (
    <Select disabled={disabled} control={control} muiLabel="Charter Filtering" name={name}>
      {Object.entries(CharterFilteringOptions).map(([key, value]) => (
        <MenuItem key={value} value={value}>
          {/* replace all _ with space for visual purposes */}
          {key.replace(/_/g, ' ')}
        </MenuItem>
      ))}
    </Select>
  );
}
